import React from 'react';
import classnames from 'classnames';
import baseStyles from 'custom/base.styl';

const LanguageTestSuccess = (props) => {
  return (
    <div>
      <h3 className={classnames(baseStyles.title_small, baseStyles.text_success, baseStyles.left, baseStyles.mb_15)}>Congratulations!</h3>
      <p className={classnames(baseStyles.title_extra_small, baseStyles.left, baseStyles.mb_20)}>
        This is the last stage of your application process. It requires completing a test task to check your skills. Good luck!
      </p>
    </div>
  );
};

export default LanguageTestSuccess;



// WEBPACK FOOTER //
// ./src/components/ApplicationOverview/LanguageTestSuccess.js